"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BasicSettings = _interopRequireDefault(require("./Component/BasicSettings.vue"));
var _RankSettings = _interopRequireDefault(require("./Component/RankSettings.vue"));
var _TaskSettings = _interopRequireDefault(require("./Component/TaskSettings.vue"));
var _SearchSettings = _interopRequireDefault(require("./Component/SearchSettings.vue"));
var _MallSettings = _interopRequireDefault(require("./Component/MallSettings.vue"));
var _CouponSquareSettings = _interopRequireDefault(require("./Component/CouponSquareSettings.vue"));
var _JudgeSettings = _interopRequireDefault(require("./Component/JudgeSettings.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'operationsManagement',
  components: {
    BasicSettings: _BasicSettings.default,
    RankSettings: _RankSettings.default,
    TaskSettings: _TaskSettings.default,
    SearchSettings: _SearchSettings.default,
    MallSettings: _MallSettings.default,
    CouponSquareSettings: _CouponSquareSettings.default,
    JudgeSettings: _JudgeSettings.default
  },
  data: function data() {
    return {
      activeKey: 'basic',
      tabs: [{
        key: 'basic',
        label: '基本设置'
      },
      // { key: 'rank', label: '排行榜设置' },
      // { key: 'task', label: '任务设置' },
      {
        key: 'search',
        label: '首页探索'
      },
      // { key: 'mall', label: '商城设置' },
      // { key: 'coupon', label: '卷广场设置' },
      {
        key: 'judge',
        label: '评审官设置'
      }]
    };
  },
  computed: {
    currentComponent: function currentComponent() {
      var map = {
        basic: 'BasicSettings',
        rank: 'RankSettings',
        task: 'TaskSettings',
        search: 'SearchSettings',
        mall: 'MallSettings',
        coupon: 'CouponSquareSettings',
        judge: 'JudgeSettings'
      };
      return map[this.activeKey] || 'BasicSettings';
    }
  },
  methods: {}
};